export default __webpack_public_path__ + "static/media/showman.b302f00e.png";